<template>
  <div class="flex justify-center" ref="element" :style="centeredPadding">
    <KonsolenkostLogo class="h-10" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';
import KonsolenkostLogo from '../../components/app/KonsolenkostLogo.vue';
import { useAdjustPaddingCentered } from '../../composables/style/useAdjustPaddingCentered';

const element = useTemplateRef<HTMLDivElement>('element');

const { centeredPadding } = useAdjustPaddingCentered(element, { minWidth: 175 });
</script>
